import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { AppService } from "../services/app.service";
import { AuthService } from "../services/auth.service";
import { PermissionType } from "../models/permission/permission-type-enum";
import { withValidatedSession } from "./session.guard";

export const permissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const appService = inject(AppService);
    const translate = inject(TranslateService);
    const authService = inject(AuthService);
    const expectedPermissions: PermissionType[] | undefined = route.data['expectedPermissions'];
    const expectedRoles: string[] | undefined = route.data['expectedRoles'];
    return withValidatedSession(() => {
        const authorized = (expectedPermissions !== undefined || expectedRoles !== undefined)
            && (expectedPermissions === undefined || authService.isAuthorized(expectedPermissions)())
            && (expectedRoles === undefined || authService.isInRole(expectedRoles)());
        if (!authorized) {
            appService.showMsg(translate.instant('noPermission'), { type: 'error' });
        }
        return authorized;
    });
}